module.exports = __webpack_public_path__ + "static/media/screen4.15937aca.png";